// extracted by mini-css-extract-plugin
export default {"collapsedBackground":"mapB15SSd6m1fSpkgHDw"};